import { Typography } from '@mui/material'

export default function createDialogTitle ({ color = 'primary', iconSize = '1.8em', title, fontSize, variant = 'h6', icon: Icon } = {}) {
  const colorPredefined = !!(color === 'primary' || color === 'secondary' || color === 'error' || color === 'warning' || color === 'info' || color === 'success')

  const IconCustom = (props) => (
    <Icon
      color={colorPredefined ? color : ''}
      sx={{
        fontSize: iconSize,
        color: colorPredefined ? '' : 'error'
      }}
    >
      {props.children}
    </Icon>
  )

  const TypographyCustom = (props) => (
    colorPredefined
      ? (
        <Typography
          color={color + '.main'}
          variant={variant}
          sx={{ fontSize }}
        >
          {props.children}
        </Typography>
        )
      : (
        <Typography
          variant={variant}
          sx={{ fontSize, color }}
        >
          {props.children}
        </Typography>
        )
  )

  return (
    {
      visible: true,
      icon: Icon ? <IconCustom /> : null,
      render: <TypographyCustom>{title} </TypographyCustom>
    }
  )
}
